import React from 'react';
import {Typography, Avatar, withStyles} from "@material-ui/core";
import {styles} from './styles';
import {People} from '@material-ui/icons'

class SignOutRedirect extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            timeout: 3
        };
    }

    onTimeout() {
        this.setState(prevState => ({timeout: prevState.timeout - 1}));
        if (this.state.timeout === 0){
            window.location.pathname = '/login'
        }
    }

    componentDidMount() {
        window.setTimeout(() => {
            this.onTimeout();
        }, 1000);
    }

    render() {
        const { classes } = this.props;
        const {timeout} = this.state;
        return (
            <main className={classes.main}>
                <div className={classes.paper}>
                    <Avatar>
                        <People/>
                    </Avatar>
                    <br/>
                    <br/>
                    <Typography align={"center"} variant='h6' color={"primary"}>You are sign out. You will be redirected
                        to Login in {timeout} seconds.</Typography>

                </div>
            </main>
        );
    }
}



export default withStyles(styles)(SignOutRedirect);
